var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoCustomTestCases(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F0F6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.666 18.6656H41.999C42.8829 18.6656 43.7307 19.0168 44.3558 19.642C44.9808 20.2672 45.332 21.1151 45.332 21.9992V45.3344C45.332 46.2185 44.9808 47.0664 44.3558 47.6916C43.7307 48.3168 42.8829 48.668 41.999 48.668H22.001C21.117 48.668 20.2692 48.3168 19.6442 47.6916C19.0191 47.0664 18.668 46.2185 18.668 45.3344V21.9992C18.668 21.1151 19.0191 20.2672 19.6442 19.642C20.2692 19.0168 21.117 18.6656 22.001 18.6656H25.334M27.0005 35.3336L30.3335 38.6672L36.9995 32M27.0005 15.332H36.9995C37.9199 15.332 38.666 16.0783 38.666 16.9988V20.3324C38.666 21.2529 37.9199 21.9992 36.9995 21.9992H27.0005C26.0801 21.9992 25.334 21.2529 25.334 20.3324V16.9988C25.334 16.0783 26.0801 15.332 27.0005 15.332Z",
    stroke: "#005BF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCustomTestCases);
export default __webpack_public_path__ + "static/media/NoCustomTestCases.835c667d5ad8fe2520d059538a44c368.svg";
export { ForwardRef as ReactComponent };